import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Checkbox,
} from '@mui/material';
import { Stack } from '@mui/system';
import { FC, useState } from 'react';

interface SignatureModalProps {
  open: boolean;
  onClose: () => void;
  onSign: (signatureName: string) => Promise<void>;
  signatureName: string;
  setSignatureName: (name: string) => void;
}

const SignatureModal: FC<SignatureModalProps> = ({
  open,
  onClose,
  onSign,
  signatureName,
  setSignatureName,
}) => {
  const handleSign = async () => {
    if (!signatureName.trim()) return;
    await onSign(signatureName);
    setSignatureName('');
  };
  const [agree, setAgree] = useState(false);
  const handleChangesStatus = (e: any) => {
    setAgree(e?.target?.checked);
  };


  const handleClose = () => {
    setSignatureName('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Sign Documents</DialogTitle>
      <DialogContent>
        <Typography
          variant="body1"
          sx={{ mb: 2 }}
        >
          Please enter your name to sign the approved documents
        </Typography>
        <TextField
          fullWidth
          label="Your Name"
          value={signatureName}
          onChange={(e) => setSignatureName(e.target.value)}
          sx={{ mb: 2 }}
        />
        {signatureName && (
          <Typography
            sx={{
              fontFamily: "'Dancing Script', cursive",
              fontSize: '2rem',
              color: 'primary.main',
              textAlign: 'center',
              mt: 2,
            }}
          >
            {signatureName}
          </Typography>
        )}
        <Stack
          display={'flex'}
          flexDirection={'row'}
          alignItems={'flex-start'}
          mt={1}
        >
          <Checkbox
            checked={agree}
            onChange={handleChangesStatus}
          />
          <Typography
            variant="body2"
            flexWrap={'wrap'}
          >
            I agree that my electronic signature is legally binding and holds the same validity as
            my handwritten signature, in accordance with applicable laws and regulations.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSign}
          disabled={!signatureName.trim() || !agree}
        >
          Sign Documents
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignatureModal;
